const getSellerItemContent = ({ i18n }) => ({
  until: i18n.gettext('HASTA'),
  off: i18n.gettext('OFF'),
});

export { getSellerItemContent };
